define('taoQtiItem/qtiXmlRenderer/renderers/interactions/HottextInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/hottextInteraction'], function(tpl){
    return {
        qtiClass : 'hottextInteraction',
        template : tpl
    };
});
